module.exports = __webpack_public_path__ + "static/img/advantage1.28009bc9.png";